<template>
    <section>
        <Header class="z-50"/>
        
          <section  class="mt-[5.9rem] lg:mt-[9rem] px-2 lg:px-0">
             <!-- section for main banner  -->
               <section class="container-4xl-w max-w-[1920px] mx-auto h-[268px]  lg:h-[300px] xl:h-[400px] shimmer">
                   <baner v-if="banerImage.length" :bannerData="banerImage" />
               </section>
  
                 <!-- section for categoryies  -->
                <section class=" container-2xl-w mx-auto px-4 2xl:px-0  min-h-40 lg:min-h-48  mb-4 lg:mb-0  mt-4 ">
                  <h2 class="text-center mb-4 public-text-title text-gray-700 ">خرید براساس دسته بندی ها</h2>
                      <!-- skeleton  -->
                       <div v-if="!mainCategory.length" class="flex justify-center">
                         <div  class="w-full" :style="{ maxWidth: `${slidesPerView * 7.5}rem` }" >
                           <Swiper class=""
                             :modules="[Navigation, Autoplay, EffectCreative]"
                             :slides-per-view="slidesPerView"
                             :spaceBetween="2"
                             >
                             <SwiperSlide v-for="n in 5" :key="n" class="flex flex-col items-center gap-2" >
                               <div class="h-20 w-20 lg:h-24 lg:w-24 shimmer rounded-full">
                               </div>
                               <p class="w-16 lg:w-20 h-4 shimmer-text ">
                               </p>
                             </SwiperSlide>
                             </Swiper>
                         </div>
                        
                       </div>
                        <categoryComponent v-else :categories="mainCategory"/>
                </section>
  
  
                <!-- section for new product  -->
                <section class="container-2xl-w w-full mx-auto min-h-[15rem]  mb-4 rounded-md overflow-hidden shimmer">
                     <newProduct :products="mostSolid" />
                </section>
  
                <!-- section for image  -->
                <section class="container-2xl-w mx-auto lg:px-4 2xl:px-0 mb-4">
                  <!-- skeleton  -->
                  <div v-if="isBannerLoading" class="grid grid-cols-2 md:grid-cols-4 gap-4">
                       <div class="rounded-lg overflow-hidden aspect-video shimmer">
                       </div>
                       <div class="rounded-lg overflow-hidden aspect-video shimmer">
                       </div>
                       <div class="rounded-lg overflow-hidden aspect-video shimmer">
                       </div>
                       <div class="rounded-lg overflow-hidden aspect-video shimmer">
                       </div>
  
                   </div> 
                   <div v-else  class="grid grid-cols-2 md:grid-cols-4 gap-4">
                       <router-link :to="{ name: 'category', params: { name: 'لباس-کار' } }">
  
                          <div class="rounded-lg overflow-hidden aspect-[500/240]">
                             <img  v-lazy="{ src: 'https://parsinekala.com' + banner500[0], loading: require('@/assets/images/loadImage1.png'), error: require('@/assets/images/loadImage2.png') }"    :alt="bannerAlt[0]" :aria-label="bannerAlt[0]" class="w-full h-full object-cover">
                          </div>
                       </router-link>
                   <router-link :to="{ name: 'category', params: { name: 'کفش-کار' } }">
  
                      <div class="rounded-lg overflow-hidden aspect-[500/240] ">
                         <img  v-lazy="{ src: 'https://parsinekala.com' + banner500[1], loading: require('@/assets/images/loadImage1.png'), error: require('@/assets/images/loadImage2.png') }"    :alt="bannerAlt[0]" :aria-label="bannerAlt[0]" class="w-full h-full object-cover">
                       </div>
                    </router-link>
                    <router-link :to="{ name: 'category', params: { name: 'بادگیر' } }">
  
                       <div class="bg-blue-500 rounded-lg overflow-hidden aspect-[500/240]">
                          <img  v-lazy="{ src: 'https://parsinekala.com' + banner500[2], loading: require('@/assets/images/loadImage1.png'), error: require('@/assets/images/loadImage2.png') }"    :alt="bannerAlt[0]" :aria-label="bannerAlt[0]" class="w-full h-full object-cover">
                       </div>
                    </router-link>
  
                   <router-link :to="{ name: 'category', params: { name: 'تیشرت-کار' } }">
                    <div class="bg-blue-500 rounded-lg overflow-hidden aspect-[500/240]">
                       <img  v-lazy="{ src: 'https://parsinekala.com' + banner500[3], loading: require('@/assets/images/loadImage1.png'), error: require('@/assets/images/loadImage2.png') }"    :alt="bannerAlt[3]" :aria-label="bannerAlt[3]" class="w-full h-full object-cover">                    
                    </div>  
                   </router-link>
                   </div> 
                           
                 </section>  
  
                <!-- section for secend categoryies  -->
                <section class="container-2xl-w mx-auto px-4 2xl:px-0  min-h-28 lg:min-h-36  mb-4 lg:mb-0  mt-4">
                        <div v-if="!reload" class="flex justify-center" >
                          <div  class="w-full " :style="{ maxWidth: `${slidesPerView * 7.5}rem` }" >
                           <Swiper class=""
                             :modules="[Navigation, Autoplay, EffectCreative]"
                             :slides-per-view="slidesPerView"
                             :spaceBetween="2"
                             >
                             <SwiperSlide v-for="n in 5" :key="n" class="flex flex-col items-center gap-2" >
                               <div class="h-20 w-20 lg:h-24 lg:w-24 shimmer rounded-full">
                               </div>
                               <p class="w-16 lg:w-20 h-4 shimmer-text ">
                               </p>
                             </SwiperSlide>
                             </Swiper>
                         </div>                 
                        </div>
                        
                        <secendCategory v-else :secendCat="sameProductInCategory" />
                </section>

                 <!-- section for best sellers  product  -->
                 <section class="container-2xl-w mx-auto  min-h-68 bg-red-200 mb-4 rounded-md overflow-hidden shimmer">
                  <keep-alive>
                    <bestSellersProduct  :products="suggested"  />                 
                  </keep-alive>
                 </section>
    
                 <!-- section for proposal  -->
                 <p class="text-center public-text-title text-gray-700 mt-8 mb-4">مقالات</p>
                 <section class="container-2xl-w mx-auto min-h-[17rem] mb-8 rounded-md overflow-hidden bg-gradient-to-br from-blue-600  via-green-400 to-blue-600 rtl flex items-center ">
                     <div v-if="isProposalLoading"  class="flex w-full h-64  rtl  shimmer" >             
                     </div>
                      <proposalComponent v-else  :proposal="proposalItem" />
                  </section>
  
  
                 <!-- section for sugested product  -->
                 <section class="container-2xl-w mx-auto min-h-[17rem]">
                    <h3 class="text-center public-text-title text-gray-700 my-4">پیشنهادهای ما</h3>
                    <sugestedComponent :products="suggested"  />
                 </section>
  
                 <section class="container-2xl-w mx-auto min-h-40 ">
                    <h3 class="text-center public-text-title mt-2 text-gray-700">برندهایی که به ما اعتماد کردند</h3>
                    <brandingComponent />
                 </section>
  
          </section>
        
        <Footer :class="isPhoneSize() ? 'mb-16' : ''" />
        <phoneFooter class="z-50"  v-show="isPhoneSize()" />
    </section>
</template>
<script setup>
import {ref,onMounted,defineAsyncComponent,computed, watch} from  'vue'
import { useSetProductStore } from '@/store/setProduct'

import { useHead } from "@vueuse/head";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-creative';
import { Navigation, Pagination, Autoplay, EffectCreative } from 'swiper';
import Header from '@/components/Header/headerSection.vue'
import phoneFooter from '@/components/Footer/phoneFooter.vue'
import baner from '@/components/Swipers/banerSwiper'
const categoryComponent=defineAsyncComponent(()=>import('@/components/Swipers/categorySwipre.vue'))
const newProduct=defineAsyncComponent(()=>import('@/components/Swipers/newProductSwier.vue'))
const secendCategory=defineAsyncComponent(()=>import('@/components/Swipers/secendCategory.vue'))
const bestSellersProduct=defineAsyncComponent(()=>import('@/components/Swipers/bestSellersProduct.vue'))
const proposalComponent=defineAsyncComponent(()=>import('@/components/Swipers/proposalSwiper.vue'))
const sugestedComponent=defineAsyncComponent(()=>import('@/components/Swipers/sugestedSwiper.vue'))
const brandingComponent=defineAsyncComponent(()=>import('@/components/Swipers/brandingSwiper.vue'))
const Footer=defineAsyncComponent(()=>import('@/components/Footer/footerSection.vue'))
import { isPhoneSize } from '@/utils/isPhoneSize.js';
import axios from 'axios';
const productStore=useSetProductStore();

productStore.setProductFromApi()
productStore.setCategoryFromApi(); 
productStore.setProposalfromApi(); 

const category=computed(()=>productStore.getCategory);
const products=computed(()=>productStore.getNewProduct);
const proposal=computed(()=>productStore.getProposal);
const sameProductInCategory=computed(()=>productStore.getCategoryProduct);
const banerImage=ref([]);
const banerPending=ref();
const mainCategory=ref([]);
const banner500 = ref([]);
const bannerAlt = ref([]);
const isBannerLoading = ref(true);
const isCategoryLoading = ref(true);
const isProposalLoading = ref(true);
const slidesPerView = ref(4);
const reload=ref(false);

const setBanner=async()=>{
   try {
      const req = await axios.post("https://parsinekala.com/backend/auth/banner/");
      banerImage.value.length=0;
      bannerAlt.value.length = 0;
      banner500.value.length = 0;
      if(req.data){
      let i=0
      req.data.forEach((item)=>{
         if (item.size === "500") {
        banner500.value[i] = item.image;
        bannerAlt.value[i] = item.alt; 
        i+=1;
      }
         banerImage.value.push(item);
         
      })
   }
      banerPending.value=req.data.length;
   } catch (error) {
      console.log('setBanner',error)
   }finally{
      isBannerLoading.value=false;
   }

}
  
const setcategory=async()=>{
    mainCategory.value.length=0;
   if(category.value.length){
    mainCategory.value = category.value.filter(
      (item) => item.layer === "Main_layer"
    );
   }
   isCategoryLoading.value = false;

}
 const proposalItem=ref([])
const setProposal=async ()=>{
    proposalItem.value.length=0;
    if(proposal.value.length){
      proposal.value.forEach((x,index)=>{
         proposalItem.value[index]=x;
      })
    }
    isProposalLoading.value = false;
}

const mostSolid=ref([]);
const mostSolidLength=ref([]);
const bestProduct=ref([]);
const suggested=ref([]);
 watch(()=>products.value.length,()=>{
   set_sold()
   setcategory()
   setProposal
 
 })


 watch(sameProductInCategory,()=>{
  if(sameProductInCategory.value.length){
    reload.value=true
  }
 })
 const set_sold = () => {
    if (products.value) {
    for (let i = 0; i < products.value.length; i++) {
      mostSolid.value[i] = products.value[i];
    }
    for (let i = 0; i < mostSolid.value.length - 1; i++) {
      let temp = {};
      for (let j = i + 1; j < mostSolid.value.length; j++) {
        if (mostSolid.value[i].sold < mostSolid.value[j].sold) {
          temp = mostSolid.value[i];
          mostSolid.value[i] = mostSolid.value[j];
          mostSolid.value[j] = temp;
        }
      }
    }
    for (let h = 0; h < 10; h++) {
      mostSolidLength.value[h] = mostSolid.value[h];
    }
    let g=0
    for (let k = 0; k < products.value.length; k++) {
      if(products.value[k].suggested)
     {
      bestProduct.value[g++]=products.value[k];
     }
      
    }

    // sort suggested data acording to update
    const x = [];
    for (let j = 0; j < bestProduct.value.length; j++) {
      // bellow section variations
      if (bestProduct.value[j].variations.length > 0) {
        let y = [];
        for (let i = 0; i < bestProduct.value[j].variations.length; i++) {
          // y for save variations created at
          y[i] = bestProduct.value[j].variations[i].created_at;
        }
        //   maxDate for calculete max value for each created_at in variations..
        let maxDate = new Date(
          Math.max.apply(
            null,
            y.map(function (date) {
              return new Date(date);
            })
          )
        );
        //   x variable save id and maxDate
        x[j] = {
          id: bestProduct.value[j].id,
          recentDate: maxDate,
        };
      }
    }
        // bellow code is sort x value from big to small
        for (let i = x.length - 1; i > 0; i--)
      for (let j = 0; j < i; j++) {
        if (x[j].recentDate - x[j + 1].recentDate < 0) {
          let temp = x[j];
          x[j] = x[j + 1];
          x[j + 1] = temp;
        }
      }
    let index = 0;
     //   bellow code set newProduct
     for (let i = 0; i < x.length; i++) {
      bestProduct.value.forEach((p) => {
        if (x[i].id === p.id) {
          suggested.value[index] = p;
          index += 1;
        }
      });
    }
  }
};

// Update slidesPerView based on page width percentage
const updateSlidesPerView = () => {
  const pageWidthPercentage = window.innerWidth;
 
    if(pageWidthPercentage> 1336)
    {
      slidesPerView.value=5
    }else if(pageWidthPercentage<= 1336 && pageWidthPercentage> 550){
      slidesPerView.value=4
    }else if(pageWidthPercentage<= 550 && pageWidthPercentage> 400){
      slidesPerView.value=3.6
    }else if(pageWidthPercentage<= 400 && pageWidthPercentage> 300){
      slidesPerView.value=2.9
    }else {
      slidesPerView.value=1.5
    }
}



onMounted(async()=>{
  updateSlidesPerView();
  window.addEventListener("resize",()=>{ updateSlidesPerView()});
   useHead({
    link: {
      rel: "canonical",
      href: "https://parsinekala.com",
    },
  });
   await setBanner();
   await setcategory();
   setTimeout(() => {
      setProposal();   
   }, 500);
    set_sold()
 
})
</script>